import { createApp } from 'vue';
import App from './App.vue';
//import router from './router'
//import './assets/main.css'

// Vuetify
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import { createVuetify } from 'vuetify';
import router from './router';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

//Amplify.configure(awsExports)

const vuetify = createVuetify({
    icons: {
        defaultSet: 'mdi', // This is already the default value - only for display purposes
    },
    components,
    directives
});

const app = createApp(App);

app.use(router);
app.use(vuetify);

app.mount('#app');
